import React from 'react'

/** Soft hyphen character — invisible on screen, allows browser to break word there. */
export const SOFT_HYPHEN = '\u00AD'

export const CONDENSED_FONT_STYLE = {
	fontFamily:
		'"Helvetica Neue Condensed", "HelveticaNeue-CondensedBlack", "Helvetica Neue", Helvetica, Arial, sans-serif',
	fontStretch: 'condensed' as const,
	fontWeight: 900,
}

/** Strip all soft hyphens from a string. */
export function stripSoftHyphens(text: string): string {
	return text.replace(/\u00AD/g, '')
}

// Renders text with newlines converted to <br /> elements.
export function renderWithBreaks(text: string, keyPrefix: string) {
	const lines = text.split('\n')
	return lines.map((line, i) => (
		<React.Fragment key={`${keyPrefix}-${i}`}>
			{i > 0 && <br />}
			{line}
		</React.Fragment>
	))
}

// Renders a title with optional gradient-highlighted words.
// highlightWords is a comma-separated string (e.g. "Praktische,adviezen").
// Matching words get an orange-to-pink gradient text effect.
// Newlines in the title are preserved as <br /> elements.
// Soft hyphens (\u00AD) in the title are preserved and passed through.
export function renderHighlightedTitle(title: string, highlightWords?: string) {
	if (!highlightWords?.trim()) return renderWithBreaks(title, 'title')

	const words = highlightWords
		.split(',')
		.map((w) => w.trim())
		.filter(Boolean)
	if (words.length === 0) return renderWithBreaks(title, 'title')

	// Build a regex that matches highlight words, allowing optional soft hyphens
	// between any characters so "Marketing" matches "Mar\u00ADketing" etc.
	const pattern = new RegExp(
		`(${words.map((w) => {
			const escaped = w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
			// Insert optional soft hyphen match between each character
			return escaped.split('').join('\u00AD?')
		}).join('|')})`,
		'gi',
	)
	const parts = title.split(pattern)

	return parts.map((part, i) => {
		const isHighlight = words.some(
			(w) => w.toLowerCase() === stripSoftHyphens(part).toLowerCase(),
		)
		if (isHighlight) {
			return (
				<span
					key={i}
					className="bg-gradient-to-r from-[#f47b30] to-[#eb0389] bg-clip-text text-transparent"
					style={{ WebkitTextFillColor: 'transparent' }}
				>
					{renderWithBreaks(part, `h-${i}`)}
				</span>
			)
		}
		return <React.Fragment key={i}>{renderWithBreaks(part, `p-${i}`)}</React.Fragment>
	})
}
